import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveHospitalNotify } from '../../procedures/hospitalNotify/store/hospitalNotify.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setHospitalNotifyQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addHospitalNotifyToTimeline } = quickActionsObject
  if (addHospitalNotifyToTimeline) {
    yield put(saveHospitalNotify())
  }
}

export function* setHospitalNotifyQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_HOSPITAL_NOTIFY_TO_TIMELINE], setHospitalNotifyQuickActionTimeLineRow)
}
